<template>
  <div>
    <el-form-item label="登录者">
        <el-switch v-model="data.isLogin" ></el-switch>
    </el-form-item>
    <el-form-item label="是否必填">
        <el-switch v-model="data.required" ></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "config-userSelect",
  props: ['data'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

